"use client";

import type { RefObject } from "react";

/**
 * refのcurrentがマウントされるまでrAFで待ち、コールバックを呼ぶ。
 * 最大300フレーム（約5秒）待ってもマウントされなければ諦める。
 */
export function waitForRef<T extends HTMLElement>(
  ref: RefObject<T | null>,
  callback: (el: T) => void,
  maxFrames = 300,
) {
  let frame = 0;
  function check() {
    if (ref.current) {
      callback(ref.current);
      return;
    }
    if (frame++ < maxFrames) {
      requestAnimationFrame(check);
    }
  }
  requestAnimationFrame(check);
}
